import { takeLatest, put, call } from 'redux-saga/effects';

import { listSafraCadastro } from '../service';
import {
  TABLE_SAFRA_CADASTRO,
  TABLE_SAFRA_CADASTRO_PENDING,
  TABLE_SAFRA_CADASTRO_SUCCESS,
  TABLE_SAFRA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListSafraCadastro(action) {
  yield put({ type: TABLE_SAFRA_CADASTRO_PENDING })

  try {
    const table = yield call(listSafraCadastro, action.args)
    yield put({ type: TABLE_SAFRA_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_SAFRA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListSafraCadastro() {
  yield takeLatest(TABLE_SAFRA_CADASTRO, sagaListSafraCadastro)
}